import React from 'react';
import PropTypes from 'prop-types';
import OverlayController from "../overlay/OverlayController";
import Dialog from "../overlay/Dialog";
import TextField from "../material/TextField";
import StateChipSelect from "../stateChipSelect/StateChipSelect";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import { compose } from 'react-apollo';
import mutationsWorkflow from '../../graphql/mutationsWorkflow';
import _ from 'lodash';

export default compose(
    mutationsWorkflow.createActionMutationHoc,
    mutationsWorkflow.updateActionMutationHoc,
    mutationsWorkflow.deleteActionMutationHoc
)(class ActionDialog extends React.Component {

    static propTypes = {
        project: PropTypes.object.isRequired,
        action: PropTypes.object,
        createAction: PropTypes.func.isRequired,
        updateAction: PropTypes.func.isRequired,
        deleteAction: PropTypes.func.isRequired,
        delegate: PropTypes.shape({
            actionPanelDidCreateAction: PropTypes.func.isRequired,
            actionPanelDidUpdateAction: PropTypes.func.isRequired,
            actionPanelDidDeleteAction: PropTypes.func.isRequired
        }).isRequired
    };

    static defaultProps = {
        action: null
    };

    constructor(props) {
        super(props);

        let defaultState = {
            title: '',
            transitionEventId: null,
            flowIdForUserAssignment: null,
            excludeAllStates: false,
            stateIdsIncluded: [],
            stateIdsExcluded: [],
            flowIdsAssigned: [],
            flowIdsUnassigned: []
        };

        if (props.action) {
            defaultState.title = props.action.title;
            defaultState.transitionEventId = props.action.transitionEventId;
            defaultState.flowIdForUserAssignment = props.action.flowIdForUserAssignment;
            defaultState.excludeAllStates = props.action.itemFilter.excludeAllStates;
            defaultState.stateIdsIncluded = props.action.itemFilter.stateIdsIncluded;
            defaultState.stateIdsExcluded = props.action.itemFilter.stateIdsExcluded;
            defaultState.flowIdsAssigned = props.action.itemFilter.flowIdsAssigned;
            defaultState.flowIdsUnassigned = props.action.itemFilter.flowIdsUnassigned;
        }

        this.state = defaultState;
    }

    onActionTitleChange = (event) => {
        this.setState({title: event.currentTarget.value});
    };

    onExcludeAllStatesChange = (excludeAllStates) => {
        this.setState({excludeAllStates: excludeAllStates});
    };

    onIncludedStateIdRemove = (stateId) => {
        this.setState({stateIdsIncluded: _.without(this.state.stateIdsIncluded, stateId)});
    };

    onExcludedStateIdRemove = (stateId) => {
        this.setState({stateIdsExcluded: _.without(this.state.stateIdsExcluded, stateId)});
    };

    onIncludedStateIdAdd = (stateId) => {
        this.setState({stateIdsIncluded: _.concat(this.state.stateIdsIncluded, stateId)});
    };

    onExcludedStateIdAdd = (stateId) => {
        this.setState({stateIdsExcluded: _.concat(this.state.stateIdsExcluded, stateId)});
    };

    onAssignedFlowIdRemove = (flowId) => {
        this.setState({flowIdsAssigned: _.without(this.state.flowIdsAssigned, flowId)});
    };

    onUnassignedFlowIdRemove = (flowId) => {
        this.setState({flowIdsUnassigned: _.without(this.state.flowIdsUnassigned, flowId)});
    };

    onAssignedFlowIdAdd = (flowId) => {
        this.setState({flowIdsAssigned: _.concat(this.state.flowIdsAssigned, flowId)});
    };

    onUnassignedFlowIdAdd = (flowId) => {
        this.setState({flowIdsUnassigned: _.concat(this.state.flowIdsUnassigned, flowId)});
    };

    onTransitionEventIdChange = (event, index, value) => {
        this.setState({transitionEventId: value});
    };

    onFlowIdForUserAssignmentChange = (event, index, value) => {
        this.setState({flowIdForUserAssignment: value});
    };

    onSubmit = (event) => {
        event.preventDefault();
        let actionInput = {
            title: this.state.title.trim(),
            transitionEventId: this.state.transitionEventId,
            flowIdForUserAssignment: this.state.flowIdForUserAssignment,
            itemFilter: {
                excludeAllStates: this.state.excludeAllStates,
                stateIdsIncluded: this.state.excludeAllStates ? [] : this.state.stateIdsIncluded,
                stateIdsExcluded: this.state.excludeAllStates ? [] : this.state.stateIdsExcluded,
                flowIdsAssigned: this.state.flowIdsAssigned ? [] : this.state.flowIdsAssigned,
                flowIdsUnassigned: this.state.flowIdsUnassigned ? [] : this.state.flowIdsUnassigned
            }
        };
        OverlayController.showActivityIndicator();
        if (this.props.action) {
            this.props.updateAction(this.props.action.id, actionInput).then(({data}) => {
                console.log("action updated:", data.updateAction);
                OverlayController.hideActivityIndicator();
                OverlayController.hideOverlay();
                this.props.delegate.actionPanelDidUpdateAction(data.updateAction);
            }).catch((error) => {
                console.log("error updating action:", error);
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
        } else {
            this.props.createAction(this.props.project.id, actionInput).then(({data}) => {
                console.log("action created:", data.createAction);
                OverlayController.hideActivityIndicator();
                OverlayController.hideOverlay();
                this.props.delegate.actionPanelDidCreateAction(data.createAction);
            }).catch((error) => {
                console.log("error creating action:", error);
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
        }
    };

    onDelete = () => {
        let actions = [
            {label: 'Cancel', handler: () => OverlayController.hideOverlay()},
            {label: 'Delete', handler: () => {
                OverlayController.showActivityIndicator();
                this.props.deleteAction(this.props.action.id).then(({data}) => {
                    console.log("action deleted:", data.deleteAction);
                    OverlayController.hideActivityIndicator();
                    OverlayController.hideOverlay(); // Hide the delete dialog
                    OverlayController.hideOverlay(); // Hide the action dialog
                    this.props.delegate.actionPanelDidDeleteAction(data.deleteAction);
                }).catch((error) => {
                    console.log("error deleting action:", error);
                    OverlayController.hideActivityIndicator();
                    OverlayController.showErrorAlert(error);
                });
            }}
        ];
        OverlayController.showOverlay({
            component: <Dialog title={`Delete action ${this.props.action.title}?`} actions={actions}/>
        });
    };

    onCancel = () => {
        OverlayController.hideOverlay();
    };

    isEnabled() {
        return this.state.title.trim().length > 0;
    }

    render() {
        let actions = [
            {label: 'Cancel', handler: this.onCancel},
            {label: this.props.action ? 'Save' : 'Create', type: "submit", form: 'actionDialogForm', disabled: !this.isEnabled()}
        ];
        if (this.props.action) {
            actions.push({label: 'Delete', secondary: true, handler: this.onDelete});
        }
        return (
            <Dialog showTitleBar={true} title="Action" actions={actions} className="actionDialog">
                <form onSubmit={this.onSubmit} id="actionDialogForm">

                    <TextField
                        floatingLabel={true}
                        labelText="Action Title"
                        placeholderText="Enter Action Title"
                        value={this.state.title}
                        onChange={this.onActionTitleChange}/>

                    <StateChipSelect
                        project={this.props.project}
                        excludeAllStates={this.state.excludeAllStates}
                        stateIdsIncluded={this.state.stateIdsIncluded}
                        stateIdsExcluded={this.state.stateIdsExcluded}
                        flowIdsAssigned={this.state.flowIdsAssigned}
                        flowIdsUnassigned={this.state.flowIdsUnassigned}
                        onExcludeAllStatesChange={this.onExcludeAllStatesChange}
                        onIncludedStateIdRemove={this.onIncludedStateIdRemove}
                        onExcludedStateIdRemove={this.onExcludedStateIdRemove}
                        onIncludedStateIdAdd={this.onIncludedStateIdAdd}
                        onExcludedStateIdAdd={this.onExcludedStateIdAdd}
                        onAssignedFlowIdRemove={this.onAssignedFlowIdRemove}
                        onUnassignedFlowIdRemove={this.onUnassignedFlowIdRemove}
                        onAssignedFlowIdAdd={this.onAssignedFlowIdAdd}
                        onUnassignedFlowIdAdd={this.onUnassignedFlowIdAdd}
                    />

                    <SelectField
                        className="custom-field custom-select-field"
                        fullWidth={true}
                        floatingLabelText="Transition Event"
                        floatingLabelFixed={true}
                        hintText="Choose event to report on item"
                        value={this.state.transitionEventId}
                        onChange={this.onTransitionEventIdChange}
                    >
                        <MenuItem value={null} primaryText=""/>
                        {this.props.project.transitionEvents.map(transitionEvent =>
                            <MenuItem key={transitionEvent.id} value={transitionEvent.id} primaryText={transitionEvent.name}/>
                        )}
                    </SelectField>

                    <SelectField
                        className="custom-field custom-select-field"
                        fullWidth={true}
                        floatingLabelText="Flow for user assignment"
                        floatingLabelFixed={true}
                        hintText="Choose flow to assign a user to"
                        value={this.state.flowIdForUserAssignment}
                        onChange={this.onFlowIdForUserAssignmentChange}
                    >
                        <MenuItem value={null} primaryText=""/>
                        {this.props.project.flows.map(flow =>
                            <MenuItem key={flow.id} value={flow.id} primaryText={flow.name}/>
                        )}
                    </SelectField>

                </form>
            </Dialog>
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/diagram/ActionDialog.js